import Swiper, {Navigation, Scrollbar} from 'swiper';
Swiper.use([ Navigation ]);
Swiper.use([ Scrollbar ]);

const siSlider = new Swiper(".siSlider", {
    slidesPerView: "auto",
    spaceBetween: 5,
    scrollbar: {
        el: ".simple-image-slider .swiper-scrollbar",
        // hide: true,
        dragSize: 65,
    },
    breakpoints: {
        // when window width is >= 320px
        640: {
            slidesPerView: "auto",
            spaceBetween: 20,
            scrollbar: {
                dragSize: 228,
            },
        },
    }
});

const gallerySlider = new Swiper(".gallerySlider", {
    slidesPerView: "auto",
    spaceBetween: 5,
    scrollbar: {
        el: ".gallery .swiper-scrollbar",
        // hide: true,
        dragSize: 65,
    },
    navigation: {
        prevEl: '.gallery-button-prev',
        nextEl: '.gallery-button-next',
    },
    breakpoints: {
        // when window width is >= 320px
        640: {
            slidesPerView: "auto",
            spaceBetween: 24,
            scrollbar: {
                dragSize: 228,
            },
        },
    }
});

const recentPostsGallerySlider = new Swiper(".recentPostsGallerySlider", {
    slidesPerView: "auto",
    navigation: {
        prevEl: '.recent-posts-gallery-button-prev',
        nextEl: '.recent-posts-gallery-button-next',
    }
});

const storySlider = new Swiper(".storySlider", {
    slidesPerView: "auto",
    spaceBetween: 12,
    scrollbar: {
        el: ".story-slider .swiper-scrollbar",
        // hide: true,
        dragSize: 65,
    },
    breakpoints: {
        // when window width is >= 320px
        640: {
            slidesPerView: "auto",
            spaceBetween: 28,
            scrollbar: {
                dragSize: 228,
            },
        },
    }
});

const reviewsSlider = new Swiper(".reviewsSlider", {
    slidesPerView: "auto",
    navigation: {
        prevEl: '.reviews-button-prev',
        nextEl: '.reviews-button-next',
    }
});

let init = false;
let cwiSlider;
function swiperCard() {
    // if (window.innerWidth <= 1024) {
        if (!init) {
            init = true;
            cwiSlider = new Swiper(".cwiSlider", {
                slidesPerView: "auto",
                navigation: {
                    prevEl: '.cwi-button-prev',
                    nextEl: '.cwi-button-next',
                }
            });
        }
    // } else if (init) {
    //     cwiSlider.destroy();
    //     init = false;
    // }
}
swiperCard();
// window.addEventListener("resize", swiperCard);

